import NotificationPopover from '@/settings/components/ActionsRender/NotificationPopover';
import styles from '@/settings/styles/settings/header-actions-render.less';
import { classes_module } from '@/utils/class-module';
import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import { Suspense, useState } from 'react';

/**
 * 全屏切换组件
 * @constructor
 */
const Fullscreen = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement
        .requestFullscreen()
        .then(() => {
          setIsFullscreen(true);
        })
        .catch((err) => {
          console.error('进入全屏模式失败', err);
        });
    } else {
      document
        .exitFullscreen()
        .then(() => {
          setIsFullscreen(false);
        })
        .catch((err) => {
          console.error('退出全屏模式失败', err);
        });
    }
  };

  return isFullscreen ? (
    <FullscreenExitOutlined onClick={toggleFullscreen} key="FullscreenExitOutlined" />
  ) : (
    <FullscreenOutlined onClick={toggleFullscreen} key="FullscreenOutlined" />
  );
};

// 导航图标列表
const ActionsRender = (props: any) => {
  if (props.isMobile) return null; // 返回 null 而不是空数组
  const show = true;

  const data = [<NotificationPopover />, <Fullscreen key="Fullscreen" />];

  return (
    <Suspense fallback={'loading...'}>
      {data.map((item: any, index: number) => (
        <div key={index} className={classes_module(styles, 'header-actions-render-icon')}>
          {item}
        </div>
      ))}
    </Suspense>
  );
};

export default ActionsRender;
